import { CURRENCY_CODES } from 'CsvImportsModule/constants';
import { RowOptionsGetter } from 'CsvImportsModule/types';

export const currencyOptionsGetter: RowOptionsGetter = () => {
  return CURRENCY_CODES;
};
